import { render, staticRenderFns } from "./TheCoCDocument.vue?vue&type=template&id=02fa9729&scoped=true&"
import script from "./TheCoCDocument.vue?vue&type=script&lang=js&"
export * from "./TheCoCDocument.vue?vue&type=script&lang=js&"
import style0 from "./TheCoCDocument.vue?vue&type=style&index=0&id=02fa9729&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fa9729",
  null
  
)

export default component.exports